module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v("Hyreshjälpen")]), _vm._v(" "), _c('p', [_vm._v("Välkommen till "), _c('strong', [_vm._v("hyreshjälpen")]), _vm._v(", en sajt som finns till för att informera om vilka regler och lagar som gäller när man skall hyra eller hyra ut.")]), _vm._v(" "), _c('p', [_vm._v("Den extrema bostadsbrist som finns, framförallt i Stockholm, har gjort att många bor i tredje hand eller hyr svart. Många betalar oerhört höga hyror.")]), _vm._v(" "), _c('p', [_vm._v("I Sverige finns det lagar som reglerar uthyrning i andra hand, håll koll på dina rättigheter så att du slipper betala pengar i onödan.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74955cf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 20
// module chunks = 0